import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsLacin(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsLacin(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsLacin - ', e);
                throw e;
            });
    };
}
export { getLogsLacin };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsLacin/actions.js